import { ICorporatePartner } from './corporate-partner.interface';
import { corporatePartners } from './corporate-partner.const';

export const getCorporatePartner = function (
  partnerId: any
): ICorporatePartner {
  for (const corpPartner of corporatePartners) {
    if (corpPartner.name === partnerId) {
      return corpPartner;
    }
  }
  return corporatePartners[0];
};
